"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.migration_67_0_0 = void 0;
/**
 * Migrate to 67.0.0
 *
 * delete ECSExperteFreigabe on kette
 * delete LeitungsaufbauUs on Leitung
 * delete ArtNrUs on all articles
 *
 */
const migration_67_0_0 = (json) => {
    if (json.Kette && json.Kette.hasOwnProperty('ECSExperteFreigabe')) {
        delete json.Kette.ECSExperteFreigabe;
        delete json.Kette.ArtNrUs;
    }
    if (json.Leitungen) {
        json.Leitungen.forEach((leitungJson) => {
            delete leitungJson.LeitungsaufbauUs;
            delete leitungJson.ArtNrUs;
        });
    }
    if (json.AEs) {
        json.AEs.forEach((aeJson) => {
            delete aeJson.ArtNrUs;
        });
    }
    if (json.Fuehrungsrinnen) {
        json.Fuehrungsrinnen.forEach((rinnenJson) => {
            delete rinnenJson.ArtNrUs;
        });
    }
    if (json.MontageSets) {
        json.MontageSets.forEach((montagesetJson) => {
            delete montagesetJson.ArtNrUs;
        });
    }
    if (json.IAs) {
        json.IAs.forEach((iaJson) => {
            delete iaJson.ArtNrUs;
        });
    }
    if (json.Zugentlastungen) {
        json.Zugentlastungen.forEach((zugentlastungJson) => {
            delete zugentlastungJson.ArtNrUs;
        });
    }
    return json;
};
exports.migration_67_0_0 = migration_67_0_0;
//# sourceMappingURL=migration_67_0_0.js.map